<template>
    <div class="additional-truck">
        <div class="title custom-title">Additional Service</div>
        <validation-observer name="additional-truck" ref="validateCargoTruck">
            <b-card class="b-card-bg">
                <b-row>
                    <div class="custom-additional">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.has_customs"
                        />
                        <div>Customs services</div>
                    </div>
                </b-row>
                <div v-if="value.has_customs" class="title custom-title">
                    Customs Declaration
                </div>
                <b-row v-if="value.has_customs">
                    <b-col lg="3">
                        <b-row>
                            <b-col>
                                <label>Customs type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Enter customs type"
                                    v-model="value.customs_type"
                                    :options="customs_types"
                                    v-if="!value.has_other_custom"
                                />
                                <b-form-input
                                    :disabled="readonly"
                                    class="iuput"
                                    v-model="value.additional_custom_input"
                                    type="text"
                                    v-if="value.has_other_custom"
                                    placeholder="Enter customs type"
                                    required
                                ></b-form-input>
                            </b-col>
                            <b-col lg="0.5" class="mt-25">
                                <div class="custom-container-other">
                                    <input
                                        :disabled="readonly"
                                        type="checkbox"
                                        class="custom-checkbox-new"
                                        v-model="value.has_other_custom"
                                    />
                                    <div>Other</div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="1"></b-col>
                    <b-col lg="3">
                        <label> Place of Custom declaration</label>

                        <b-form-input
                            :disabled="readonly"
                            class="iuput"
                            v-model="value.place_of_custom"
                            type="text"
                            placeholder=" Place of Custom declaration"
                            required
                        ></b-form-input>
                    </b-col>
                    <b-col lg="1"></b-col>
                    <b-col lg="3">
                        <label>HS Code</label>

                        <b-form-input
                            :disabled="readonly"
                            class="iuput"
                            v-model="value.HS_code_truck"
                            type="text"
                            placeholder="HS Code"
                            required
                        ></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
        </validation-observer>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
    BButton,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
} from "bootstrap-vue";
export default {
    components: {
        BButton,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BInputGroupPrepend,
        BFormDatepicker,
        BRow,
        BCol,
        BTable,
        BCard,
        Select2,
    },
    data() {
        return {
            iconAdd: require("@/assets/images/icons/add.png"),
            remove: require("@/assets/images/icons/remove.png"),
            check_country_pick_up: null,
            check_country_delivery: null,
        };
    },
    props: {
        value: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {},
    computed: {
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
            "quotations",
            "locations",
        ]),
    },
    watch: {},
    methods: {},
};
</script>

<style lang="scss">
.additional-truck {
    .custom-title {
        align-items: center;
        display: flex;
        height: 43px;
    }
    .container-checkbox {
        display: flex;
        margin-top: 29px;
        align-items: center;
        gap: 5px;
    }
    label {
        color: #000000;
        font-weight: 600;
    }
    .form-control {
        border: 0 !important;
    }
    .b-card-bg {
        height: auto;
        padding: 1.5rem;
        @media (max-width: 992px) {
            height: 350px;
        }
    }
    .mx-input {
        border: none !important;
    }
    .mt-20 {
        margin-top: 25px;
    }
    .custom-delete {
        margin-top: 5px;
        cursor: pointer;
    }
    .custom-add-line {
        cursor: pointer;
    }
    .select2-selection--single {
        border: none !important;
    }
    .custom-additional {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-left: 15px;
        div {
            color: #000000;
            font-size: medium;
            font-weight: 600;
        }
    }
    .mt-25 {
        margin-top: 28px !important;
    }
    .custom-container-other {
        display: flex;
        align-items: center;
        gap: 5px;
        div {
            font-weight: 600;
            color: #000000;
        }
    }
    .select2-selection--single:before {
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
    }
}
</style>
